import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'

export default class VacancyApplicationDeclinedChatMessage extends AbstractChatMessage {
  constructor(data: LX.VacancyApplicationDeclinedChatMessage) {
    super(data)
    this.body = data.body
  }

  static fromServer(data: LX.VacancyApplicationDeclinedChatMessage) {
    return new VacancyApplicationDeclinedChatMessage(data)
  }

  getShortMessage() {
    return 'The application for this Full-time Job has been declined.'
  }
}
